<template>
  <b-form-group v-bind="commonFormGroupProps">
    <b-form-select
      v-model="internalValue"
      :options="monthOptions"
      @input="$emit('input', $event)"
      class="flex-grow-1"
      placeholder="Select month"
    />
    <b-button
        v-if="item.resetButton"
        variant="outline-secondary"
        size="sm"
        class="ml-2"
        @click="reset"
    >
      Reset
    </b-button>
  </b-form-group>
</template>

<script>
import { BFormSelect, BButton } from 'bootstrap-vue'
import { formMixin } from '@/mixins/formMixin'

export default {
  mixins: [formMixin],
  components: { BFormSelect, BButton },
  props: ['item', 'value'],
  data () {
    return { internalValue: this.value }
  },
  watch: {
    value (val) { this.internalValue = val }
  },
  computed: {
    commonFormGroupProps () {
      return { ...this.getCommonFormGroupProps() }
    },
    monthOptions () {
      const months = [{ value: '', text: '' }]
      const now = new Date()
      for (let i = 0; i < 12; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
        months.push({
          value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
          text: d.toLocaleString('default', { month: 'long', year: 'numeric' })
        })
      }
      return months
    }
  },
  methods: {
    reset () {
      this.internalValue = null
      this.$emit('input', null)
    }
  }
}
</script>